import { AccessTokenExpiredError, InvalidCredentialsError, NotFoundError, RateLimitError, UnexpectedError, ValidationError, } from "@for-it/domain-lib";
import { BucketOperationFailedError } from "./errors/bucket-operation-failed-error.js";
import { BucketUnusableError } from "./errors/bucket-unusable-error.js";
import { InvalidSubdomainError } from "./errors/invalid-subdomain-error.js";
import { PaymentCredentialsInvalidError } from "./errors/payment-credentials-invalid-error.js";
import { SubdomainAlreadyExistsError } from "./errors/subdomain-already-exists-error.js";
import { TenantBootstrapFailedError } from "./errors/tenant-bootstrap-failed-error.js";
import { TenantNotFoundError } from "./errors/tenant-not-found-error.js";
export const DomainErrors = {
    AccessTokenExpiredError,
    BucketOperationFailedError,
    BucketUnusableError,
    InvalidCredentialsError,
    InvalidSubdomainError,
    NotFoundError,
    PaymentCredentialsInvalidError,
    RateLimitError,
    SubdomainAlreadyExistsError,
    TenantBootstrapFailedError,
    TenantNotFoundError,
    UnexpectedError,
    ValidationError,
};
